module.exports = __webpack_public_path__ + "static/media/welcomeDemo4.35a3c2a8.png";